import { useEffect, useState } from "react";
import WaveSurfer from "wavesurfer.js";

export const useWavesurfer = (containerRef: any, options: any) => {
  const [wavesurfer, setWavesurfer] = useState<WaveSurfer>()

  useEffect(() => {
    if (!containerRef.current) return

    const parent = containerRef.current.parentElement
    if (!parent) return

    let ws: WaveSurfer | undefined

    const initWaveSurfer = (width: number) => {
      if (!containerRef.current) return

      containerRef.current.style.width = `${width}px`
      containerRef.current.style.height = '100%'

      ws = WaveSurfer.create({
        ...options,
        barRadius: 2,
        barWidth: 2,
        barGap: 1,
        waveColor: 'rgba(255,255,255,0.5)',
        progressColor: '#c0392b',
        cursorColor: '#e74c3c',
        cursorWidth: 1,
        barHeight: 1,
        height: 60,
        normalize: true,
        fillParent: true,
        hideScrollbar: true,
        container: containerRef.current,
      })

      setWavesurfer(ws)
    }

    const initialWidth = parent.clientWidth
    if (initialWidth > 0) {
      initWaveSurfer(initialWidth)
      return () => { ws?.destroy() }
    }

    // Parent has 0 width on mount — wait until layout gives it a size
    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const width = entry.contentRect.width
        if (width > 0 && !ws) {
          initWaveSurfer(width)
          observer.disconnect()
          break
        }
      }
    })

    observer.observe(parent)

    return () => {
      observer.disconnect()
      ws?.destroy()
    }
  }, [options, containerRef])

  return wavesurfer
}
